import React from "react"

import ApplicationStepper from "@/components/application/ApplicationStepper"
import VehicleCollectionConfirmation from "@/components/application/VehicleCollectionConfirmation"
import AppLayout from "@/components/layout/AppLayout"

const VehicleCollectionConfirmationPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 pb-8 md:px-8">
        <ApplicationStepper />
        <h1 className="mb-2 text-center text-2xl font-bold text-jungle md:text-2xl">
          Collection Confirmed
        </h1>
        <p className="mb-8 text-center text-gray-600">
          Your vehicle collection appointment has been confirmed
        </p>
        <VehicleCollectionConfirmation />
      </div>
    </AppLayout>
  )
}

export default VehicleCollectionConfirmationPage
